import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
// import { ILoginModel, IRegisterModel, IUserModel } from "src/model";
import { ServiceInjectable } from "src/utils/services";

/**
 * 订单类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class skcServerOrderService extends ServiceBase
{
    /**
     * 服务下单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async skcServerOrder(data: any): Promise<IHttpResponse>
     {
         let response = await this.apis.skcServerOrder({ data });
         return response;
     }

     /**
     * 订单列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
      public async skcServerOrderPageList(data: any): Promise<IHttpResponse>
      {
          let response = await this.apis.skcServerOrderPageList({ data });
          return response;
      }

      /**
     * 支付方式
     * @public
     * @returns {Promise<IHttpResponse>}
     */
       public async skcServerOrderConfirm(data: any): Promise<IHttpResponse>
       {
           let response = await this.apis.skcServerOrderConfirm({ data });
           return response;
       }

     /**
     * 获取服务订单详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getSkcServerOrder(id: number): Promise<IHttpResponse>
    {
    let response = await this.apis.getSkcServerOrder({ urlPath: { id } });
        return response;
    }

    /**
     * 获取订单支付结果
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getPayResult(id: number): Promise<IHttpResponse>
    {
    let response = await this.apis.getPayResult({ urlPath: { id } });
        return response;
    }

    /**
     * 取消服务下单
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async cancelOrder(id: number): Promise<IHttpResponse>
     {
     let response = await this.apis.cancelOrder({ params:{id} });
         return response;
     }

     /**
     * 线下付款
     * @public
     * @returns {Promise<IHttpResponse>}
     */
      public async offlinePay(data: any): Promise<IHttpResponse>
      {
          let response = await this.apis.offlinePay({ data });
          return response;
      }

      /**
     * 线下付款审核
     * @public
     * @returns {Promise<IHttpResponse>}
     */
       public async offlinePayAudit(data: any): Promise<IHttpResponse>
       {
           let response = await this.apis.offlinePayAudit({ data });
           return response;
       }
}